import React, { useEffect, useCallback } from "react"
import { ExitBannerIcon } from "./icons"
import { navigate } from "gatsby"

const ExitBanner = () => {
  const [visible, setVisible] = React.useState(true)

  const handleEsc = useCallback((event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      navigate("https://www.bom.gov.au")
    }
  }, [])

  useEffect(() => {
    window.addEventListener("keydown", handleEsc)
    return () => window.removeEventListener("keydown", handleEsc)
  }, [handleEsc])

  return (
    <div
      className="exit-wrapper"
      style={{ display: visible ? "block" : "none" }}
    >
      <a
        href="https://www.bom.gov.au"
        className="exit-banner"
        style={{ display: visible ? "block" : "none" }}
      >
        <div className="exit-banner__inner">
          <div className="exit-banner__content">
            <div className="exit-banner__icon">
              <ExitBannerIcon />
            </div>
            <p>
              Quick Exit{" "}
              <span className="more">
                - Click anywhere in this banner or press ESC to exit
              </span>
            </p>
          </div>
        </div>
      </a>
      <button
        onClick={() => setVisible(false)}
        className="exit-banner__hide"
        style={{ display: visible ? "block" : "none" }}
      >
        Hide Bar
      </button>
    </div>
  )
}

export default ExitBanner
